import { render, staticRenderFns } from "./AgreementCreate.vue?vue&type=template&id=881cf710"
import script from "./AgreementCreate.vue?vue&type=script&lang=js"
export * from "./AgreementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports